export default __webpack_public_path__ + "7823337bcd2e5da5764c5fb762ce9a3e.png";